Vue.component("user-profile", {

    props: ["userProfile", "roles", "canChangePermissions", "invitation"],

    data () {
        return {
            user: this.userProfile,
            form: new AppForm({
                role: this.userProfile.role,
                default_mailbox: this.userProfile.default_mailbox_id
            }),
            passwordForm: new AppForm({
                password: "",
                password_confirmation: ""
            }),
            invitationForm: new AppForm({}),
            isChangingPassword: false,
            pendingInvite: this.invitation
        };
    },

    computed: {

        showUserStatusOptions () {
            return this.user.id !== this.app.userId && this.userCan("manage-users");
        },

        isOwnProfile () {
            return this.user.id === this.app.userId;
        },

        showDefaultMailboxInput () {
            return !["Tenant", "Landlord"].includes(this.user.role);
        }
    },

    methods: {

        showInvitationForm () {
            return this.user !== undefined && this.user.team_user_status === "pending";
        },

        hasPendingInvite () {
            return this.pendingInvite !== null;
        },

        sendInvite () {
            App.post("/users/invite/" + this.user.id + "/send", this.invitationForm)
            .then((response) => {
                this.pendingInvite = response;
                toastr.success("Invitation Sent!");
            });
        },

        canChangeRole () {

            // Role for guest users can't be changed
            if (["Tenant", "Landlord"].includes(this.user.role)) {
                return false;
            }

            if (this.canChangePermissions) {

                // Only a manager can change manager roles
                if ("Manager" === this.user.role) {
                    return this.userHasRole("Account Owner") || this.userHasRole("Manager") || this.userHasRole("Support");
                }

                return true;

            }

            return false;
        },

        allowUserToSelectRole (role) {

            if (this.userHasRole("Account Owner") || this.userHasRole("Support")) {
                return true;
            }

            if (this.userHasRole("Manager") && role !== "Account Owner") {
                return true;
            }

            return !["Account Owner", "Manager"].includes(role);

        },

        roleChanged () {
            if (this.form.role !== this.user.role) {
                if ("Account Owner" === this.form.role) {
                    this.showRoleChangeMessage("Make user the " + this.form.role, "Making this user the " + this.form.role + " will change your role to Manager. The user will be given full account ownership and permissions.");
                } else if ("Manager" === this.form.role) {
                    this.showRoleChangeMessage("Make user the " + this.form.role, "Changing role to Manager will grant this user full permission rights.");
                } else {
                    this.showRoleChangeMessage("Change role to " + this.form.role, "Changing the role of a user will reset their permissions.");
                }
            }
        },

        showRoleChangeMessage (title, message) {
            swal({
                title: title,
                text: message,
                showCancelButton: false
            });
        },

        saveProfile () {
            this.form.first_name = this.user.first_name;
            this.form.last_name = this.user.last_name;
            this.form.email = this.user.email;
            this.form.job_title = this.user.job_title;
            this.form.mobile = this.user.mobile;
            this.form.phone = this.user.phone;
            this.form.timezone = this.user.timezone;
            App.patch("/users/profile/" + this.user.id + "/update", this.form)
            .then((response) => {
                this.user.role = this.form.role;
                this.user.default_mailbox_id = this.form.default_mailbox;
                toastr.success("Saved!");
                Bus.$emit("permissions-changed", response.permissions);
            });

        },

        toggleChangePassword () {
            this.isChangingPassword = !this.isChangingPassword;
            if (!this.isChangingPassword) {
                this.passwordForm.password = "";
                this.passwordForm.password_confirmation = "";
            }
        },

        savePassword () {
            App.post("/users/profile/" + this.user.id + "/password/reset", this.passwordForm)
            .then(() => {
                toastr.success("Password changed!");
                this.toggleChangePassword();
            });
        },

        activate () {
            this.updateStatus("active");
        },

        deactivate () {
            this.updateStatus("inactive");
        },

        updateStatus (status) {
            axios.patch("/" + App.state.currentTeam.id + "/users/" + this.user.id + "/status", {
                _method: "PATCH",
                status: status
            }).then(response => {
                this.user.team_user_status = status;
                toastr.success(response.data);
            }).catch(error => {
                toastr.error(error.message);
            });

        }

    }

});
